import React from 'react'
import {
	InstructionList,
	InstructionListItem,
	InstructionListItemIndex,
} from './style'
import _ from 'lodash'
import { useSelector } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'

const getInstruction = (instruction, locale) => {
	return _.isObject(instruction) && instruction.allLangs?.length
		? _.find(instruction.allLangs, (lang) => {
				return lang.language === locale
		  })?.text
		: instruction.text
		? instruction.text
		: instruction
}

const Instructions = ({ items = [] }) => {
	const { locale = '' } = useSelector(({ root }) => root)

	return (
		<InstructionList>
			{items?.map((instruction, i) => {
				let text = getInstruction(instruction, locale)
				return (
					!!text && (
						<InstructionListItem key={i}>
							<InstructionListItemIndex>
								{i + 1}
							</InstructionListItemIndex>
							{ReactHtmlParser(text)}
						</InstructionListItem>
					)
				)
			})}
		</InstructionList>
	)
}

export default Instructions
